import { Head } from "@inertiajs/react"
import ProductionHeader from "@/components/admin/production/ProductionHeader"
import BatchForm from "@/components/admin/production/BatchForm"
import type {
  AssetOption,
  SharedProductionProps,
  VariantOption,
} from "@/components/admin/production/types"

interface NewProps extends SharedProductionProps {
  item_variants: VariantOption[]
  active_assets: AssetOption[]
  cost_kinds: string[]
  initial?: Record<string, unknown>
  errors?: Record<string, string[]>
}

export default function BatchNew({
  store,
  paths,
  item_variants,
  active_assets,
  cost_kinds,
  initial,
  errors,
}: NewProps) {
  return (
    <>
      <Head title="Nouveau batch · Production" />
      <ProductionHeader
        title="Nouveau batch"
        subtitle="Enregistrez ce qui a été produit et combien ça a coûté."
        storeName={store.name ?? undefined}
        paths={paths}
      />
      <main className="mx-auto max-w-4xl px-6 py-8">
        <BatchForm
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          initial={initial as any}
          item_variants={item_variants}
          active_assets={active_assets}
          cost_kinds={cost_kinds}
          submitUrl={paths.batches_index}
          method="post"
          errors={errors}
          cancelUrl={paths.batches_index}
        />
      </main>
    </>
  )
}
